export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./messages.vue?vue&type=template&id=5f0e3747"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/messages/messages.vue?vue&type=template&id=5f0e3747
// module id = 644S
// module chunks = 0